var callOptional = function callOptional(f) {
  return function () {
    if (f) return f.apply(void 0, arguments);
  };
};

export { callOptional };
